import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
    return (
        <div className="footer pt-5">
            <Container>
                <div className="text-center py-5 get-in-touch"  data-aos="fade-up" data-aos-duration="1500">
                    <p className="py-4 get-in-touch-content">Get in touch with us</p>
                    <div className="media-icons mb-5">
                        <a href="https://www.facebook.com/sparkplustech/" ><i className="fab fa-facebook-f"></i></a>                    
                        <a href="https://twitter.com/sparkplustech" ><i className="fab fa-twitter"></i></a>                 
                        <a href="https://in.linkedin.com/company/sparkplustech" ><i className="fab fa-linkedin-in"></i></a>
                        <a href="https://medium.com/@SparkPlusTech" ><i className="fab fa-medium-m"></i></a>                  
                    </div>
                    <div className="dividerr">
                        <div></div>
                        <p>OR</p>
                    </div>
                    <button className="upload-btn px-5 py-3 my-5">Write Your Query</button>
                </div>
            </Container>
            <div className="last-wrapper m-0 p-0 text-center">
                <p className="py-5 m-0">© SPARK+ 2019 All rights reserved</p>
            </div>
        </div>
    )
}

export default Footer
